import $ from 'jquery';
import MicroModal from 'micromodal';
import { disableScroll, enableScroll } from '../utils/dom.js';
import { notifier } from '../utils/notifier.js';
console.log('Modal.js loaded!')
export function initModal() {
	MicroModal.init({
		closeTrigger: false,
		openTrigger: false,
		debugMode: true,
	})
	//
	// $('body').on('click', '[data-micromodal-trigger]', function (e) {
	// 	e.preventDefault();
	// 	console.log('open')
	// 	if (e.target === e.currentTarget) {
	// 		$('.is-open').each(function () {
	// 			MicroModal.close($(this).attr('id'));
	// 		});
	// 		const modalId = $(this).data('micromodal-trigger');
	// 		if (modalId) {
	// 			MicroModal.show(modalId);
	// 			disableScroll();
	// 		}
	// 	}
	// });
	//
	// $('body').on('mousedown', '[data-close-modal]', function (e) {
	// 	e.preventDefault();
	// 	if (e.target === e.currentTarget) {
	// 		const modalId = $(this).closest('[data-micromodal]').attr('id');
	// 		if (modalId) {
	// 			MicroModal.close(modalId);
	// 			enableScroll();
	// 			console.log(application.isAuthorized)
	// 			console.log(window.location.pathname)
	// 			console.log(modalId)
	// 			if(!application.isAuthorized && window.location.pathname === '/personal/' && (modalId === 'modal-register' || modalId === 'modal-account')) {
	// 				window.location = '/';
	// 			}
	// 		}
	// 	}
	// });

	$('#modal-register form').on('submit', function (e) {
		e.preventDefault();
		const form = $(this);
		const formData = new FormData(form[0]);
		const json = Object.fromEntries(formData.entries());
		$.ajax('/api/register', {
			method: 'POST',
			dataType: 'json',
			data: JSON.stringify(json),
			success: function (data) {
				if (!data.result) {
					notifier.alert(data.message);
				} else {
					location.href = '/personal';
				}
			},
		});
	});

	$('#modal-account form').on('submit', function (e) {
		e.preventDefault();
		const form = $(this);
		const formData = new FormData(form[0]);
		const json = Object.fromEntries(formData.entries());
		$.ajax('/api/login', {
			method: 'POST',
			dataType: 'json',
			data: JSON.stringify(json),
			success: function (data) {
				if (!data.result) {
					notifier.alert(data.message);
				} else {
					location.href = '/personal';
				}
			},
		});
	});
}
